import React, { useState, useEffect } from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./Components/Sidebar";
import Navbar from "./Components/Navbar";
import MaintenancePopup from "./Components/MaintenancePopup";
import GetBannerPage from "./newtest/banner/GetBanner";


const Layout = () => {
  const isNonMobile = useMediaQuery("(min-width:960px)"); 

  const [isSidebarOpen, setIsSidebarOpen] = useState(); 

  useEffect(() => {
    setIsSidebarOpen(isNonMobile); 
  }, [isNonMobile]);

  const [isPopupOpen, setIsPopupOpen] = useState(true); 

  const closePopup = () => {
    setIsPopupOpen(false); 
  };

  return (
    <Box
      display="flex"
      width="100%"
      height="100vh" 
      sx={{
        overflow: 'hidden',  
      }}
    >
      <Sidebar
        user={"user"}
        isNonMobile={isNonMobile}
        drawerWidth="250px"
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflowY: 'auto',  
        }}
      >
        <Navbar
          user={"user"}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <Box sx={{ padding: '16px' }}>
          <Outlet />
      {/* <MaintenancePopup isOpen={isPopupOpen} onClose={closePopup} /> */}

        </Box>
            <GetBannerPage />

      </Box>
    </Box>
  );
};

export default Layout;
